import { Stack, Typography } from '@mui/material';

import { UnstyledButton } from '@/components/form/baseInputs/Button/UnstyledButton';
import { RotatingArrows } from '@/components/progress/RotatingArrows';
import { COLORS } from '@/styles/tokens/colors';
import { FONT_WEIGHTS } from '@/styles/tokens/fonts';

export interface ProcessingIndicatorProps {
  variant: 'dark' | 'light';
  onClick: () => void;
}

export function ProcessingIndicator({
  variant,
  onClick,
}: ProcessingIndicatorProps) {
  return (
    <UnstyledButton onClick={onClick}>
      <Stack
        spacing={0.5}
        alignItems="center"
        direction="row"
        sx={{ py: 0.75, px: 1 }}
      >
        <RotatingArrows
          size={16}
          color={variant === 'dark' ? COLORS.TEXT.PRIMARY : COLORS.GRAY[300]}
        />
        <Typography
          fontWeight={FONT_WEIGHTS.regular}
          variant="title-xs"
          component="div"
          color={variant === 'dark' ? COLORS.TEXT.PRIMARY : COLORS.GRAY[50]}
        >
          Processing...
        </Typography>
      </Stack>
    </UnstyledButton>
  );
}
